import JSZip from "jszip";

import { getExtensionFile, getFileFromUrl } from "./string";

const triggerBlobDownload = (blob, fileName) => {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.style.display = "none";
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();

  setTimeout(() => {
    document.body.removeChild(anchor);
    URL.revokeObjectURL(objectUrl);
  }, 100);
};

export const downloadUrlsAsZip = async ({
  urls = [],
  fileName = "download.zip",
}) => {
  if (!Array.isArray(urls) || urls.length === 0) {
    return false;
  }

  const blobs = await Promise.all(urls.map((url) => getFileFromUrl(url)));
  if (blobs.some((blob) => !blob)) {
    return false;
  }

  const zip = new JSZip();

  blobs.forEach((blob, index) => {
    const extension = getExtensionFile(urls[index]) || "jpg";
    zip.file(`${index + 1}.${extension}`, blob, { compression: "STORE" });
  });

  const content = await zip.generateAsync({
    type: "blob",
    compression: "STORE",
  });

  triggerBlobDownload(content, fileName);
  return true;
};

export const downloadCarouselZip = async ({
  urls = [],
  fileName = "carousel.zip",
}) => downloadUrlsAsZip({ urls, fileName });
